function init() {
    document.addEventListener('click', e => {
        if (!e.target || !e.target.classList.contains('js-toggle-class')) {
            return true;
        }

        let selector = e.target.getAttribute('data-js-tc-selector');
        let classToToggle = e.target.getAttribute('data-js-tc-toggle-class');

        if (!selector || !classToToggle) {
            return true;
        }

        document.querySelectorAll(selector).forEach(target => {
            toggleClassOnTarget(target, classToToggle);
        });
    });
}

function toggleClassOnTarget(target, className) {
    if(target.classList.toggle) {
        target.classList.toggle(className);
    } else {
        if(target.classList.contains(className)) {
            target.classList.remove(className)
        } else {
            target.classList.add(className)
        }
    }
}

module.exports = {
    init
}



// WEBPACK FOOTER //
// ./modules/toggleClass.js